import React from 'react';
import { Widget } from './components';

const settings = {};

const LockHomeDemo = () => <Widget {...settings} />;

export default LockHomeDemo;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/LockHomeDemo/LockHomeDemo.js